import { PaginationResource } from '../@api/Strapi';
import { PaginationConfig } from '../@api/Sylius';
import { PaginationInterface } from './Pagination';

export const transformSyliusPaginationToPagination = (totalItems: number, paginationConfig: PaginationConfig): PaginationInterface => {
    const totalPages = Math.ceil(totalItems / paginationConfig.itemsPerPage);

    return {
        totalResults: totalItems,
        page: paginationConfig.page,
        pageSize: paginationConfig.itemsPerPage,
        totalPages,
    };
};

export const transformStrapiPaginationToPagination = (resource: PaginationResource): PaginationInterface => ({
    totalResults: resource.total,
    page: resource.page,
    pageSize: resource.pageSize,
    totalPages: resource.pageCount,
});
